import { GapDensityMapThemeContext } from "@app/projects/network-assessment/maps/gap-density-map/contexts/GapDensityMapThemeContext";
import { GAP_DENSITY_MAP_STYLE } from "@app/projects/network-assessment/maps/gap-density-map/GapDensityMapsConstants";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { QESButton } from "@app/shared/qes-standards/Button";
import { FC, useContext, useEffect, useState } from "react";

type GapDensityMapColorComponentProps = {
  bucket: 0 | 1 | 2 | 3 | 4;
}

export const GapDensityMapColorComponent: FC<GapDensityMapColorComponentProps> = ({ bucket }) => {

  const themeContext = useContext(GapDensityMapThemeContext);

  const [color, setColor] = useState<string>("#FFFFFF");

  useEffect(() => {
    const colors = [themeContext.themeToEdit.noGapColor,
    themeContext.themeToEdit.gapColor1,
    themeContext.themeToEdit.gapColor2,
    themeContext.themeToEdit.gapColor3,
    themeContext.themeToEdit.gapColor4];

    setColor(colors[bucket as number] || "#FFFFFF");
  }, [themeContext.themeToEdit])

  const handleEditColor = (newColor: string) => {
    const editedTheme = { ...themeContext.themeToEdit };
    const colorKeys = ["noGapColor", "gapColor1", "gapColor2", "gapColor3", "gapColor4"] as const;
    editedTheme[colorKeys[bucket]] = newColor;
    setColor(newColor);
    themeContext.setThemeToEdit(editedTheme);
  }

  const isSelected = themeContext.editingBucketIndex === bucket;

  return (
    <>
      <div className="gap-density-map__theme-component-container">
        <div
          className="gap-density-map__theme-component">
          {GAP_DENSITY_MAP_STYLE.COLOR_NAMES[bucket]}
          <div className="gap-density-map__theme-colors">
            <div
              style={{
                backgroundColor: color,
                border: GAP_DENSITY_MAP_STYLE.GAP_DENSITY_MAP_THEME_COLOR_CIRCLE_BORDER,
                borderRadius: "50%",
                boxShadow: isSelected ? "0 0 0 3px #1890ff, 0 0 0 6px #e6f7ff" : undefined,
                height: GAP_DENSITY_MAP_STYLE.GAP_DENSITY_MAP_THEME_COLOR_CIRCLE_DIAMETER,
                transition: "box-shadow 0.2s, background 0.2s",
                width: GAP_DENSITY_MAP_STYLE.GAP_DENSITY_MAP_THEME_COLOR_CIRCLE_DIAMETER,
              }}
            />
          </div>
        </div>
        <QESButton
          qesTestId={`gap-density-map__color-component-${themeContext.themeToEdit.name}-${bucket}`}
          qesType="secondary"
          onClick={() => {
            themeContext.setEditingBucketIndex(bucket);
            document.getElementById(`gap-density-map__theme-color-picker--${themeContext.themeToEdit.name}-${bucket}`)?.click();
          }}
        >
          <div className="gap-density-map__theme-edit-button-content">
            <QesIcon iconName={QesIcons.PencilV1} isDecorative />
            Edit
          </div>
        </QESButton>
      </div>
      <input
        type="color"
        id={`gap-density-map__theme-color-picker--${themeContext.themeToEdit.name}-${bucket}`}
        className="qes-secondary"
        style={{
          border: 0,
          height: 0,
          padding: 0,
          width: 0
        }}
        onChange={(e) => handleEditColor(e.target.value)}
        value={color}
        data-testid={`gap-density-map__theme-color-picker--${themeContext.themeToEdit.name}-${bucket}`}
      />
    </>
  )
}